import RegisterPasien from "../../components/RegisterPasien/HomePagePasienOnlineDoctor";

export default function Register() {
  return (
    <div style={{backgroundColor:"white"}}>
      <RegisterPasien/>
    </div>
  );
}
